import { CustomSvg, SvgIconDefaultProps } from '@libs/components';

const CircleCheckIcon: React.FC<SvgIconDefaultProps> = ({
  className,
  testId,
}) => {
  return (
    <CustomSvg
      className={className}
      data-cy={testId}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z"
        fill="#3B9F17"
      />
      <path
        d="M4.40039 7.99961L6.79757 10.3996L11.6004 5.59961"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </CustomSvg>
  );
};
export default CircleCheckIcon;
